import { render, staticRenderFns } from "./SpotlightItem.vue?vue&type=template&id=10a553d8"
import script from "./SpotlightItem.vue?vue&type=script&lang=js"
export * from "./SpotlightItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports